import type { PointOfCareRecord } from "@/modules/patients/detail/progress-note/point-of-care/types"

export const isMedicalEmergency = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  medical === "MEDICAL_EMERGENCY_OR_PERMANENCE" && !actual

export const isActualEmergency = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  medical !== null && actual === "MEDICAL_EMERGENCY_OR_PERMANENCE"

const isMedicalTelecare = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  (medical === "TELECARE" || medical === "EMERGENCY_CALL" || medical === "INCOMPLETE_TELECONSULTATION") && !actual

export const isActualTelecare = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  (medical !== null && actual === "EMERGENCY_CALL") ||
  (medical !== null && actual === "INCOMPLETE_TELECONSULTATION") ||
  (medical !== null && actual === "TELECARE")

export const isTelecareContent = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  isMedicalTelecare(medical, actual) || isActualTelecare(medical, actual)

export const isMedicalHospitalEmergency = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  medical === "HOSPITAL_EMERGENCY_ROOM" && !actual

export const isActualHospitalEmergency = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  medical !== null && actual === "HOSPITAL_EMERGENCY_ROOM"

export const isMedicalGeneralPractitioner = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  medical === "GENERAL_PRACTITIONER" && !actual

export const isActualGeneralPractitioner = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  medical !== null && actual === "GENERAL_PRACTITIONER"

export const isMedicalSpecialist = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  medical === "SPECIALIST" && !actual

export const isActualSpecialist = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  medical !== null && actual === "SPECIALIST"

export const isMedicalHospitalElective = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  medical === "HOSPITAL_ELECTIVE" && !actual

export const isActualHospitalElective = (medical: PointOfCareRecord, actual: PointOfCareRecord) =>
  medical !== null && actual === "HOSPITAL_ELECTIVE"

export const isExternalAssistance = (medical: PointOfCareRecord) => medical === "EXTERNAL_ASSISTANCE"
